import Tile from "../Tile";
import moment from "moment";
import UploadedFile from "../../Utility/Crud/UploadedFile";
import User from "../../Utility/Crud/User";
import MainContext from "../../Context/MainContext/MainContext";

export default class TileUploadedFile extends Tile {
    static contextType = MainContext; // For legacy class components
    /**
      * @returns {string} The UploadedFile file name.
      */
    getTitle() {
        return this.props.uploadedFile ? UploadedFile.getDisplayName(this.props.uploadedFile) : "None";
    }

    /**
     * @returns {string} The uploadedFiles's uploaded at and uploaded by.
     */
    getSubtitle() {
        if (!this.props.uploadedFile) {
            return null;
        }

        const parts = [];
        parts.push(moment(this.props.uploadedFile.uploadedAt).format('M/D/YYYY h:mm A'));
        parts.push(User.getDisplayName(this.context.usersIndexed[this.props.uploadedFile.uploaderId]));
        return parts.join(" • ");
    }

    /**
     * Renders the avatar.
     */
    renderAvatar() {
        return null;
    }
}
